import { create } from "zustand";
import { createJSONStorage, devtools, persist } from "zustand/middleware";
import { I2DImgTryonStateAndAction, initialState } from "./initialState";
import { setLocalItem } from "@/lib/commonService";
import { USR_PD } from "@/config/constConf";
import { USER_PHOTO } from "@/config/interface";

export const use2DImgTryonStore = create<I2DImgTryonStateAndAction>()(
    devtools(
        persist(
            (set, get) => ({
                ...initialState,
                SET_SELECT_PD: (selectPd: any) => {
                    set({
                        selectPd,
                    });
                },
                SET_UPLOAD_LOADING: (loading: boolean) => {
                    set({
                        loading,
                    });
                },
                SET_USR_PD_H5: (pd: any) => {
                    setLocalItem(USR_PD, pd);
                    set({
                        pdModalVisible: false,
                        usrPd: pd,
                    });
                },
                SET_IMG_LIST: (payload: any) => {
                    set({
                        imgList: payload.sort(
                            (a: USER_PHOTO, b: USER_PHOTO) =>
                                b.photo_add_time - a.photo_add_time,
                        ),
                    });
                },
                SET_USR_CONFIRM_IMG_INFO: (payload: any) => {
                    set({
                        notEyeImgTooHigh:
                            payload.notEyeImgTooHigh !== undefined
                                ? payload.notEyeImgTooHigh
                                : true,
                        usrConfirmImg: payload.usrConfirmImg,
                    });
                },
                SET_NOT_ALLOW_UPLOAD: (notAllowUploadVisible: boolean) => {
                    set({ notAllowUploadVisible });
                },
                SET_FIRST_NOTICE: (firstNotice: boolean) => {
                    set({ firstNotice });
                },
                AFTER_SAVE_EYE_POSITION: (payload: any) => {
                    set({
                        imgList: payload,
                        usrConfirmImg: null,
                    });
                },
                SHOW_IMG: (payload: any) => {
                    set({
                        ...payload,
                    });
                },
                SET_L_POSITION: (lPosition: any) => {
                    set({ lPosition });
                },
                SET_R_POSITION: (rPosition: any) => {
                    set({ rPosition });
                },
                SET_GLASSES_INFO: (payload: any) => {
                    set({
                        glassesImgSrc: payload.glassesImgSrc,
                        glassesSize: [payload.width, payload.height],
                    });
                },
                SET_GLASSES_COLOR_INFO: (payload: any) => {
                    set({
                        glassesColorImgSrc: payload.glassesColorImgSrc,
                        glassesSize: payload.width
                            ? [payload.width, payload.height]
                            : null,
                    });
                },
                SET_STYLE: (payload: any) => {
                    set({ style: payload });
                },
                SET_PD_MODAL: (pdModalVisible: boolean) => {
                    set({ pdModalVisible });
                },
                SET_MOUSE_LOCATION: (mouseLocation: any) => {
                    set({ mouseLocation });
                },
                SET_UPLOAD_ERROR: (uploadError: any) => {
                    set({ uploadError });
                },
                SET_IMG_LOADING: (imgLoading: boolean) => {
                    set({ imgLoading });
                },
                SET_USR_UPLOAD_FILE: (userUploadFile: any) => {
                    set({ userUploadFile });
                },
                SET_DEL_LOADING: (delBtnLoading: any) => {
                    set({ delBtnLoading });
                },
                SET_NOTICE_SHOW: (noticeShow: boolean) => {
                    set({ noticeShow });
                },
            }),
            {
                name: "2d-try-on-storage",
                storage: createJSONStorage(() => sessionStorage),
            },
        ),
        {
            name: "2d-try-on-storage",
        },
    ),
);
